import { useState } from "react";

export const useVisibility = (
  initially: boolean = false,
  showDelay: number = 100,
  hideDelay: number = 200
) => {
  const [isRendered, setIsRendered] = useState(initially);
  const [isVisible, setIsVisible] = useState(initially);

  const show = () => {
    setIsRendered(true);
    setTimeout(() => setIsVisible(true), showDelay);
  };

  const hide = () => {
    setIsVisible(false);
    setTimeout(() => setIsRendered(false), hideDelay);
  };

  const toggle = () => (isVisible ? hide() : show());

  return { isRendered, isVisible, show, hide, toggle };
};
